import Polygon111x from '../../assets/img/polygon-1-1@1x.png';
import Line41x from '../../assets/img/line-4@1x.png';
import Path721x from '../../assets/img/path-7-2@1x.png';
import POSAugmentedReality2v2 from '../../assets/img/POS_augmented_reality_2_V2.png';
import IcoArBl from '../../assets/img/ICO_AR_BL.png';

import './index.css';
import './responsive.css';

function ARSection() {
  return (
    <div className="ar_-feature_-block-JUZYnQ">
      
    
      <div className="content-left">
        <img className="pos_augmented_reality_2_v1-cYO3cG" src={POSAugmentedReality2v2} />
      </div>

      <div className="content-right">
        <div className="ico_ar-M740L3">
          <img className="ico_ar" src={IcoArBl} />
        </div>

        <div className="go-beyond-with-augme-M740L3 titles">
          <h2>Go beyond with Augmented Reality (AR) for total audience immersion</h2>
        </div>

      
        <div className="deliver-an-immersive-M740L3 bullets">
          Deliver an immersive experience to you audiences. Bring solutions to the table at any scale, and reveal
          internal workings and structure with powerful animations.
        </div>
      
        <div className="ar_bullets">
          <div className="ar_-bullet">
            <img className="ar_-bullet1-M740L3" src={Polygon111x} />
            <p>Use Augmented Reality to present solutions in any environment</p>
          </div>
          
          <div className="ar_-bullet">
            <img className="ar_-bullet2-M740L3" src={Polygon111x} />
            <p>Interact with complex objects</p>
          </div>

          <div className="ar_-bullet">
            <img className="ar_-bullet3-M740L3" src={Polygon111x} />
            <p>Add more context using animated overlays to highlight benefits</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ARSection;